import axios from "axios";
import { axiosGet, userData } from "../../../Helpers";

export const loadMessagesData = async (setLoading) => {
  let apiRespponse = await axiosGet(
    `chat/getUserAllConversation/${userData?.id}`
  );
  setLoading(false);
  console.log(apiRespponse, "ALl conversation");

  return apiRespponse.data.data;
};
